module.exports = __webpack_public_path__ + "static/rolling_vs_standard_array-036a781d2e1811717a6eb934638675cf.png";